import { combineReducers } from 'redux';
import rutasReducers from './rutas';
import loginReducers from './login';
import pasosFlujo1Reducers from './pasosFlujo1';
import pasosFlujo2Reducers from './pasosFlujo2';
import pasosFlujo3Reducers from './pasosFlujo3';
import pasosFlujo4Reducers from './pasosFlujo4';
import pasosFlujo0Reducers from './pasosFlujo0';
import constantesReducers from './constantes';
import flujoThankPage from './flujoTyp';
import usuarioReducer from './usuario';
import obtenerParametrosReducer from './http/obtenerParametros';
import portalcobranzasReducers from './portalcobranzas';


const rootReducer = combineReducers({
    rutas: rutasReducers,
    pasosF1 : pasosFlujo1Reducers,
    pasosF2 : pasosFlujo2Reducers,
    pasosF3 : pasosFlujo3Reducers,
    pasosF4 : pasosFlujo4Reducers,
    pasosF0 : pasosFlujo0Reducers,
    isLogin: loginReducers,
    constantes: constantesReducers,
    flujo: flujoThankPage,
    usuario: usuarioReducer,
    parametros: obtenerParametrosReducer,
    datosPortalCobranzas: portalcobranzasReducers,

});

export default rootReducer;

